import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MarkdownModule } from 'ngx-markdown';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppInitService } from './core/services/app-init.service';
import { LayoutModule } from './layout/layout.module';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { httpInterceptor } from './shared/services/http-interceptor.service';
import { featureCampaignsName, moduleCampaignsReducers } from './modules/campaign-management/campaigns/reducers';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    StoreModule.forRoot({}, {}),
    StoreModule.forFeature(featureCampaignsName, moduleCampaignsReducers),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
    FontAwesomeModule,
    MarkdownModule.forRoot(),
    SharedModule,
    AppRoutingModule,
    LayoutModule,
  ],
  providers: [
    { provide: 'eliquaRestURL', useValue: environment.eliquaRestURL },
    { provide: 'clientName', useValue: environment.clientName },
    { provide: 'production', useValue: environment.production },
    { provide: MatDialogRef, useValue: {} },
    {
      provide: APP_INITIALIZER,
      useFactory: (appInit: AppInitService) => () => appInit.init(),
      deps: [AppInitService],
      multi: true,
    },
    provideHttpClient(withInterceptors([httpInterceptor])),
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
